import type {Breadcrumb, ChildContainerProps, LayoutConfig, LayoutContextProps, LayoutState,} from "../../../types";
import React, {useState} from "react";
import Seo from "../../../components/Seo";

export const LayoutContext = React.createContext({} as LayoutContextProps);

export const LayoutProvider = (props: ChildContainerProps) => {
    const [breadcrumbs, setBreadcrumbs] = useState<Breadcrumb[]>([]);
    const [layoutConfig, setLayoutConfig] = useState<LayoutConfig>({
        ripple: false,
        inputStyle: "outlined",
        menuMode: "static",
        menuTheme: "colorScheme",
        colorScheme: "light",
        theme: "green",
        scale: 13,
    });

    const [layoutState, setLayoutState] = useState<LayoutState>({
        staticMenuDesktopInactive: false,
        overlayMenuActive: false,
        overlaySubmenuActive: false,
        profileSidebarVisible: false,
        configSidebarVisible: false,
        staticMenuMobileActive: false,
        menuHoverActive: false,
        resetMenu: false,
        sidebarActive: false,
        anchored: false,
    });

    const onMenuToggle = () => {
        if (isOverlay()) {
            setLayoutState((prevLayoutState) => ({
                ...prevLayoutState,
                overlayMenuActive: !prevLayoutState.overlayMenuActive,
            }));
        }

        if (isDesktop()) {
            setLayoutState((prevLayoutState) => ({
                ...prevLayoutState,
                staticMenuDesktopInactive:
                    !prevLayoutState.staticMenuDesktopInactive,
            }));
        } else {
            setLayoutState((prevLayoutState) => ({
                ...prevLayoutState,
                staticMenuMobileActive: !prevLayoutState.staticMenuMobileActive,
            }));
        }
    };

    const showConfigSidebar = () => {
        setLayoutState((prevLayoutState) => ({
            ...prevLayoutState,
            configSidebarVisible: true,
        }));
    };

    const showProfileSidebar = () => {
        setLayoutState((prevLayoutState) => ({
            ...prevLayoutState,
            profileSidebarVisible: !prevLayoutState.profileSidebarVisible,
        }));
    };

    const isOverlay = () => {
        return layoutConfig.menuMode === "overlay";
    };

    const isSlim = () => {
        return layoutConfig.menuMode === "slim";
    };

    const isSlimPlus = () => {
        return layoutConfig.menuMode === "slim-plus";
    };

    const isHorizontal = () => {
        return layoutConfig.menuMode === "horizontal";
    };

    const isDesktop = () => {
        return window.innerWidth > 991;
    };


    // const themeColor = localStorage.getItem('colorScheme') || "light";
    // console.log("colorScheme", themeColor);

    const value = {
        layoutConfig,
        setLayoutConfig,
        layoutState,
        setLayoutState,
        onMenuToggle,
        showConfigSidebar,
        showProfileSidebar,
        isSlim,
        isSlimPlus,
        isHorizontal,
        isDesktop,
        breadcrumbs,
        setBreadcrumbs,
    };


    const seoData = {
        title: "ChemCare Dashboard",
        description: "ChemCare Chemist is a trusted, customer-focused pharmacy providing genuine medicines, healthcare products, and professional pharmacist guidance. With affordable prices, reliable service, and a commitment to quality, ChemCare Chemist is your dependable partner for everyday health and wellness needs.",
        canonical: "https://chemcaredepot.selopian.us",
        author: "ChemCare",
        openGraph: {
            title: "ChemCare Dashboard",
            description: "ChemCare Chemist is a trusted, customer-focused pharmacy providing genuine medicines, healthcare products, and professional pharmacist guidance. With affordable prices, reliable service, and a commitment to quality, ChemCare Chemist is your dependable partner for everyday health and wellness needs.",
            image: "https://chemcaredepot.selopian.us/logo.png",
            url: "https://chemcaredepot.selopian.us",
            type: "website",
            locale: "en_US"
        },
        twitter: {
            card: "https://chemcaredepot.selopian.us/logo-symbool.png",
            title: "ChemCare Dashboard",
            description: "ChemCare Chemist is a trusted, customer-focused pharmacy providing genuine medicines, healthcare products, and professional pharmacist guidance. With affordable prices, reliable service, and a commitment to quality, ChemCare Chemist is your dependable partner for everyday health and wellness needs.",
            image: "https://chemcaredepot.selopian.us/logo.png"
        }
    };

    return (
        <LayoutContext.Provider value={value}>
            <>
                <Seo {...seoData} />
                {props.children}
            </>
        </LayoutContext.Provider>
    );
};
